import { Bar, BarChart, CartesianGrid, Legend, XAxis, YAxis } from 'recharts';
import { CustomAppLayout } from '../../../layout';


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { useEffect, useMemo, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, FormField, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import React from 'react';
import Favorites from '../../../../../components/extras/Favorites';
import SelectEquipments from '../../../../../components/selects/selectEquipments';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, colorsArray } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';
import { mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
const _preserve = React.version;

export const ReportsOpsFuelConsumption = () => {

    const { menu } = useGlobalState();
    const [stage, setStage] = useState("A")

    useGlobalState();
    const { navigate } = useRouter();
    const [idEquipments, setIdEquipments] = useState<number[]>([4729, 4726, 4730]);
    const [chartData, setChartData] = useState<[]>([]);

    const handleSearchData = async () => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/reports/ops/fuelconsumption',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ idEquipments: idEquipments }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0 && data.report) {

                setChartData(data.report)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }
    const registrations = useMemo(() => {
        return [...new Set(chartData.map((item: any) => item.registration))];
    }, [chartData]);
    const formattedChartData = useMemo(() => {
        const grouped = chartData.reduce((acc: any, item: any) => {
            const { MovementMonth, registration, TotalLiters } = item;
            if (!acc[MovementMonth]) {
                acc[MovementMonth] = { MovementMonth };
            }
            acc[MovementMonth][registration] = TotalLiters;
            return acc;
        }, {});
        return Object.values(grouped);
    }, [chartData]);
    useEffect(() => {

    }, []);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Consumo de combustibles</Header>
                    <SpaceBetween size="xs" direction="horizontal">
                        <FormField label="Material">
                            <SelectEquipments isClub={1} value={idEquipments || []}
                                onConfirm={(detail) => {
                                    setIdEquipments(detail);
                                }}
                            />
                        </FormField>
                        <FormField label="&nbsp;">
                            <Button style={{ root: btnIconForm }} onClick={() => {
                                handleSearchData()
                            }}><Icon path={mdiMagnify} size={1} /></Button>
                        </FormField>
                    </SpaceBetween>
                    {registrations.length > 0 && chartData.length > 0 && (
                        <BarChart
                            data={formattedChartData} // Use the transformed data here
                            style={{ width: '100%', maxWidth: '100%', height: '100%', maxHeight: '70vh', aspectRatio: 1.618 }}>

                            <Legend />
                            <XAxis dataKey="MovementMonth" />
                            <YAxis />
                            <CartesianGrid strokeDasharray="3 3" />
                            {registrations.map((reg, index) => (
                                <Bar
                                    key={reg as string}
                                    type="monotone"
                                    dataKey={reg as string}
                                    fill={colorsArray[index % colorsArray.length]}
                                />
                            ))}
                        </BarChart>
                    )}
                </SpaceBetween>
            }
        />
    )
};
